var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ValidationProvider", {
    attrs: {
      rules: Object.assign({}, _vm.mergedRules),
      mode: "aggressive",
      slim: ""
    },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function(ref) {
          var errors = ref.errors
          var failedRules = ref.failedRules
          return [
            _c(
              "td",
              {
                class: [_vm.getValidationErrorClasses(failedRules)].concat(
                  _vm.classes
                )
              },
              [
                _c(
                  "numeric-input-control",
                  _vm._b(
                    {
                      attrs: {
                        required: _vm.required,
                        "aria-invalid": _vm.required && errors.length > 0,
                        minValue: _vm.minValue,
                        maxValue: _vm.maxValue
                      },
                      model: {
                        value: _vm.modifiedValue,
                        callback: function($$v) {
                          _vm.modifiedValue = $$v
                        },
                        expression: "modifiedValue"
                      }
                    },
                    "numeric-input-control",
                    _vm.$attrs,
                    false
                  )
                )
              ],
              1
            )
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }